import styled from 'styled-components';

export default styled.div`
  grid-area: user;
  align-self: end;
  font-size: 0.9rem;
  color: black;
`;
